import { Children } from "react";

export default function ResponsiveRail({ children, mobileWidth = "78vw", mobileMinWidth = 240 }) {
  const items = Children.toArray(children);

  return (
    <>
      {/* Full-width editorial cards on narrow phones; two columns only once
          there is enough room to keep titles and status legible. */}
      <div className="sm:hidden grid grid-cols-1 min-[480px]:grid-cols-2 items-stretch gap-x-4 gap-y-7 min-[480px]:gap-y-8 -mx-4 px-4 pb-3">
        {items.map((child, i) => (
          <div key={i} className="[&>*]:w-full [&>*]:min-w-0">
            {child}
          </div>
        ))}
      </div>

      {/* Desktop: auto-fill responsive grid */}
      <div className="hidden sm:block">
        <div className="grid grid-cols-[repeat(auto-fill,minmax(260px,1fr))] items-stretch gap-x-6 gap-y-9">
          {items.map((child, i) => (
            <div key={i} className="[&>*]:w-full [&>*]:min-w-0">
              {child}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}